import React from "react";
import PropTypes from "prop-types";
import { Image } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

const ProductCard = ({ product, addCartItem, currencySymbol }) => {
  const quantity = product.manage_inventory
    ? parseFloat(product.sellable_qty || 0)
    : 999;
  const isOutOfStock = quantity === 0;

  return (
    <Card
      key={product.id}
      onClick={() => !isOutOfStock && addCartItem(product, 1)}
      className={`cursor-pointer transition-all hover:shadow-md border-border overflow-hidden group ${
        isOutOfStock
          ? "opacity-60 cursor-not-allowed"
          : "hover:border-primary/50"
      }`}
    >
      <CardContent className="p-2">
        <div className="space-y-2">
          {/* Image Section */}
          <div className="w-full aspect-square bg-muted rounded-md overflow-hidden relative border border-border">
            {product.media && product.media[0]?.url ? (
              <img
                src={product.media[0].url}
                alt={product.name}
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-muted-foreground">
                <Image size={32} />
              </div>
            )}
          </div>

          {/* Product Details Section */}
          <div className="space-y-1">
            <h6
              className="font-semibold text-xs leading-tight line-clamp-2"
              title={product.name}
            >
              {product.name}
            </h6>

            {product.sku && (
              <small className="text-[10px] text-muted-foreground block truncate">
                {product.sku}
              </small>
            )}

            {product.model?.name && (
              <small className="text-[10px] text-muted-foreground block truncate">
                {product.model.name}
              </small>
            )}

            <div className="flex items-center justify-between gap-2 pt-1">
              <span className="font-bold text-sm text-primary truncate">
                {currencySymbol}
                {product.sell_price.toFixed(2)}
              </span>

              <Badge
                variant={isOutOfStock ? "destructive" : "default"}
                className="px-1.5 py-0 h-4 text-[9px] shrink-0"
              >
                {product.manage_inventory ? `${quantity}` : "∞"}
              </Badge>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
  addCartItem: PropTypes.func.isRequired,
  currencySymbol: PropTypes.string,
};

export default ProductCard;
